export default {
    maptiler: {
        url:
            "https://api.maptiler.com/maps/basic-v2/256/{z}/{x}/{y}.png?key=iF5ifQbEVsInMezY2fBP",
        attribution:
            '&copy; <a href="https://www.maptiler.com/">MapTiler</a> &copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
    },
};